<template>
  <div class="container">
    <AudioIcon />
    <LevelStart :title="title" :name="name" :forwardPath="forwardPath" />
  </div>
</template>

<script>
import { tLevel5 } from '@game/utils';
import LevelStart from '@game/LevelStart.vue';
import { audioMixinLevel5 } from '@game/mixins/audioMixin.js';

export default {
  name: 'Scene0',
  mixins: [audioMixinLevel5],
  components: {
    LevelStart
  },
  data() {
    return {
      title: tLevel5('scene0.title'),
      name: tLevel5('scene0.name'),
      forwardPath: '/game/level-5/scene-1',
    }
  },
}
</script>

<style scoped>
.container {
  /* animation */
  position: absolute;

  width: 100%;
  height: 100%;
}
</style>